import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { SectionCard } from "./SectionCard";
import { PurchasedRow } from "./PurchasedRow";
import { useGetUserPurchaedDataQuery } from "../../../../store/Company/companyApiSlice";

/* Companies the user has bought a Web Profile for. */
export const PurchasedCompanies = () => {
  const { userInfo, token } = useSelector((state) => state.auth);
  const { data } = useGetUserPurchaedDataQuery({
    token,
    id: userInfo?.individual?.[0]?.userID,
  });

  const rows = data?.data || [];

  return (
    <SectionCard title="Your Purchases">
      {rows.length === 0 ? (
        <div className="py-8 text-center">
          <p className="text-[14px] text-[var(--muted)] font-sans">
            All your purchases will appear here.
          </p>
          <Link
            to="/search"
            onClick={() => localStorage.setItem("UpgradePlan", true)}
            className="mt-4 inline-flex h-[42px] items-center rounded-lg border border-[var(--coral)] px-5 text-[14px] font-semibold text-[var(--coral)] transition-colors hover:bg-[var(--coral-soft)]"
          >
            Start Purchasing
          </Link>
        </div>
      ) : (
        <>
          <div className="flex justify-between border-b border-[var(--line-2)] pb-1.5 pt-3.5 text-[11.5px] font-bold uppercase tracking-[0.06em] text-[var(--muted)] font-sans">
            <span>Business name</span>
            <span>Date of purchase</span>
          </div>
          <div className="u1-no-scrollbar max-h-[300px] overflow-y-auto">
            {/* Spread as the original does — the row reads companyID and
                purchaseDate off the item itself. */}
            {rows.map((item, i) => (
              <PurchasedRow key={`${item.companyID}-${i}`} {...item} token={token} />
            ))}
          </div>
        </>
      )}
    </SectionCard>
  );
};

export default PurchasedCompanies;
